import script from "./ProductOrderBumps.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductOrderBumps.vue?vue&type=script&setup=true&lang=js"

import "./ProductOrderBumps.vue?vue&type=style&index=0&id=1e7b4ee4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e7b4ee4"]])

export default __exports__